import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { 
    MELOGY_BACKGROUND_MEDIUM_LIGHT_GREY,
    MELOGY_BACKGROUND_2XLIGHT_GREY, 
} from "../../style/colors";

const maxHeight = 256;

const StyledScrollbar = styled.div`
    width: 100%;
    max-height: ${maxHeight}px;
    overflow-y: ${(props) => (props.hasOverflow ? "scroll" : "hidden")};
    overflow-x: hidden;
    cursor: pointer;

    &::-webkit-scrollbar {
        width: 2px;
    }
    &::-webkit-scrollbar-track {
        background: ${MELOGY_BACKGROUND_MEDIUM_LIGHT_GREY};
    }
    &::-webkit-scrollbar-thumb {
        background: ${MELOGY_BACKGROUND_2XLIGHT_GREY};
        cursor: grab;
    }
    &::-webkit-scrollbar-thumb:hover {
        cursor: grab;
    }
    &::-webkit-scrollbar-thumb:active {
        cursor: grabbing;
    }
`;

const Scrollbar = ({ children }) => {
    const scrollRef = useRef(null);
    const [hasOverflow, setHasOverflow] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (scrollRef.current) {
                setHasOverflow(scrollRef.current.scrollHeight > maxHeight);
            }
        };

        checkOverflow();
        window.addEventListener("resize", checkOverflow);

        return () => {
            window.removeEventListener("resize", checkOverflow);
        };
    }, [children]);

    return (
        <StyledScrollbar ref={scrollRef} hasOverflow={hasOverflow}>
            <div style={{ paddingRight: hasOverflow ? "16px" : "0px" }}>
                {children}
            </div>
        </StyledScrollbar>
    );
};

export default Scrollbar;
